<app-breadcrumb [title]="'Media Files'"></app-breadcrumb>
<div class="container-fluid mt--6">
  <div class="row">
    <div class="col">
      <div class="card">
        <div id="progress-avatar" class="progress progress-xs" [class.fade]="!isProgress">
          <div [style.width]="barWidth + '%'" class="progress-bar progress-bar-striped progress-bar-animated bg-success"
            role="progressbar" aria-valuemin="0" aria-valuemax="100">
          </div>
        </div>
        <div class="card-body">
          <div class="fileinput-zone border position-relative">
            <div class="text-center py-5">
              <span class="d-block">Drag files here to upload</span>
            </div>
            <input type="file" name="files[]" multiple="" (change)="uploadFile($event.target.files)">
          </div>
        </div>
        <div class="table-responsive">
          <table class="table align-items-center table-flush">
            <colgroup>
              <col style="width: 10%">
              <col style="width: 20%">
              <col style="width: 40%">
              <col style="width: 10%">
              <col style="width: 10%">
            </colgroup>
            <thead class="thead-light">
              <tr>
                <th *ngFor="let c of columns">
                  <div *ngIf="c.isSortable" (click)="sortBy(c.key)">
                    <div class="d-flex justify-content-between align-items-center">
                      {{ c.title }}
                      <div class="ml-2">
                        <i *ngIf="query.sort === c.key" class="ni" [class.ni-bold-down]="query.sortDir == 'Ascending'"
                          [class.ni-bold-up]="query.sortDir == 'Descending'"></i>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="!c.isSortable">
                    {{ c.title }}
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let v of queryResult.items">
                <td>{{ v.id }}</td>
                <td>{{ v.title }}</td>
                <td>{{ v.mediaUrl }}</td>
                <td>
                  <button type="button" (click)="copy(v.mediaUrl)" class="btn btn-sm btn-success">Copy</button>
                </td>
                <td>
                  <button type="button" (click)="delete(v.id)" class="btn btn-sm btn-danger">Delete</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <pagination [total-rows]="queryResult.totalRows" [current-page]="query.page" [page-size]="query.pageSize">
        </pagination>
      </div>
    </div>
  </div>
</div>